import styled from 'styled-components';

import { getScoreBands } from '@components/status-cell/helpers';

import { ProgressColors, ScoreBandColors } from '@components/view-key/view-key-colors';

import ThemeHelper from '@themes/theme-helper';

export const backgroundColorTypes = {
  cellDefault: '#fff',
  cellSelected: '#b2e4ff'
};

export const backgroundHoverColorTypes = {
  cellSelected: '#9fcce5',
  cellAssigned: '#c3cfbd',
  default: '#e5e5e5'
};

export const getBackgroundColorByAccuracy = range =>
  getScoreBands({
    currentlyAssigned: ScoreBandColors.currentlyAssigned.default,
    completed1to20: ScoreBandColors.completed1to20.default,
    completed21to40: ScoreBandColors.completed21to40.default,
    completed41to60: ScoreBandColors.completed41to60.default,
    completed61to80: ScoreBandColors.completed61to80.default,
    completed81to100: ScoreBandColors.completed81to100.default,
    range
  });

const getBackgroundHoverColor = ({ backgroundColorCheckValue, isSelected }) => {
  if (isSelected) return backgroundHoverColorTypes.cellSelected;

  return getScoreBands({
    currentlyAssigned: isSelected ? backgroundHoverColorTypes.cellSelected : ScoreBandColors.currentlyAssigned.hover,
    completed1to20: ScoreBandColors.completed1to20.hover,
    completed21to40: ScoreBandColors.completed21to40.hover,
    completed41to60: ScoreBandColors.completed41to60.hover,
    completed61to80: ScoreBandColors.completed61to80.hover,
    completed81to100: ScoreBandColors.completed81to100.hover,
    range: backgroundColorCheckValue
  });
};

const getBackgroundColorByIsProgressFilter = ({ isSelected, backgroundColorCheckValue }) => {
  if (isSelected) return backgroundColorTypes.cellSelected;
  if (!backgroundColorCheckValue) return backgroundColorTypes.cellDefault;

  return getBackgroundColorByAccuracy(backgroundColorCheckValue);
};

const getCellBackgroundColor = props => {
  const { showCurrentAssigned, isSelected, backgroundColorCheckValue } = props;

  if (showCurrentAssigned) return ProgressColors.currentlyAssigned;

  return getBackgroundColorByIsProgressFilter({
    isSelected,
    backgroundColorCheckValue
  });
};

export const Cell = styled.span(props => {
  const { isSelected, backgroundColorCheckValue, showCurrentAssignmentTriangle } = props;

  const { colours } = ThemeHelper.getTheme(props);

  return `
    position: relative;
    width: 54px;
    min-height: 33px;
    max-height: 33px;
    box-sizing: border-box;
    border: ${isSelected ? '1px solid #00A5FF' : `1px solid ${colours.grey[400]}`};
    border-top: ${!isSelected && 'none'};
    border-right: ${!isSelected && 'none'};
    cursor: pointer;
    background-color: ${getCellBackgroundColor(props)};
    
    &:last-child {
      border-bottom: ${isSelected ? '1px solid #00A5FF' : 'none'};
    }

    &:hover {
      background-color: ${getBackgroundHoverColor({ backgroundColorCheckValue, isSelected })};
    }

    &:before {
      display: ${showCurrentAssignmentTriangle ? 'block' : 'none'};
      position: absolute;
      content: '';
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-top: 16.5px solid transparent;
      border-left: 16.5px solid transparent;
      border-bottom: 16.5px solid ${ProgressColors.currentlyAssigned};
    }
`;
});

export const ResultWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  [class^='svgIconComponent'] {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;

export const Result = styled.div`
  color: white;
  font-size: 14px;

  &:hover {
    font-size: 15px;
  }
`;

export const HoverWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 250px;
  font-weight: 400;
  padding: 4px;
`



// WEBPACK FOOTER //
// ./components/status-cell/styled.js